import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_VENUE_FOR_EDIT = "GET_VENUE_FOR_EDIT";

export interface GetVenueForEditAction extends Action {
  type: typeof GET_VENUE_FOR_EDIT;
  id: string;
  organization: OrganizationKeyName;
}

export const getVenueForEdit = (
  organization: OrganizationKeyName,
  id: string
): GetVenueForEditAction => ({
  type: GET_VENUE_FOR_EDIT,
  id,
  organization,
});
